export const menuItems = [
  {
    title: "Beranda",
    url: "/",
    cName: "nav_links",
    transition: 0.1,
  },
  {
    title: "Pekerjaan",
    url: "/explorejobs",
    cName: "nav_links",
    transition: 0.2,
  },
];
